import { render, staticRenderFns } from "./LayoutCenter.vue?vue&type=template&id=35cb4fc6&scoped=true"
import script from "./LayoutCenter.vue?vue&type=script&lang=ts"
export * from "./LayoutCenter.vue?vue&type=script&lang=ts"
import style0 from "./LayoutCenter.vue?vue&type=style&index=0&id=35cb4fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cb4fc6",
  null
  
)

export default component.exports